(() => {
  const selectors = {
    section: '.coastd-hybrid-hero',
    chips: '.coastd-hybrid-hero__chips'
  };

  function initSection(section) {
    const chips = section.querySelector(selectors.chips);
    if (!chips || chips.dataset.coastdReady === 'true') return;

    chips.dataset.coastdReady = 'true';

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    chips.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') {
        isDown = true;
        startX = event.clientX;
        startScrollLeft = chips.scrollLeft;
        chips.setPointerCapture(event.pointerId);
      }
    });

    chips.addEventListener('pointermove', (event) => {
      if (!isDown) return;
      chips.scrollLeft = startScrollLeft - (event.clientX - startX);
    });

    const stopDragging = () => {
      isDown = false;
    };

    chips.addEventListener('pointerup', stopDragging);
    chips.addEventListener('pointercancel', stopDragging);
    chips.addEventListener('mouseleave', stopDragging);
  }

  function initAll(root = document) {
    root.querySelectorAll(selectors.section).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
